
import React, { Component, Fragment } from 'react'


class CenterElement extends Component {


    componentDidMount = () => {

    }
    componentDidUpdate = () => {


        if (this.txt != null)
            window.x(this.txt)

        // try{

        //}
        //  catch{

        //  }
    }

    render = () => {

        let { content, style, textAlign } = this.props
        return (
            <table style={{ width: "100%", height: "100%" }}>
                <tbody>
                    <tr>
                        <td style={{ width: "100%", height: "100%", verticalAlign: "middle", textAlign: textAlign, direction: "rtl" }}>
                            <span style={style} ref={(el) => (this.txt = el)}
                                dangerouslySetInnerHTML={{ __html: content }}
                            ></span>
                        </td>
                    </tr>
                </tbody>
            </table>
        )
    }
}

export default CenterElement